/** Badge modifier by fuel_key / label (Аи-92 green, Аи-95 yellow, ДТ black). */
export function fuelBadgeClass(fuelKeyOrLabel) {
  const s = String(fuelKeyOrLabel || '')
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/ё/g, 'е')

  if (/ai92|аи-?92/.test(s)) return 'fuel-planner__fuel-card-badge--ai92'
  if (/ai95|аи-?95/.test(s)) return 'fuel-planner__fuel-card-badge--ai95'
  if (
    s === 'dt' ||
    s === 'dtw' ||
    /^dt\b/.test(s) ||
    /^дт/.test(s) ||
    s.includes('дизель')
  ) {
    return 'fuel-planner__fuel-card-badge--dt'
  }
  return 'fuel-planner__fuel-card-badge--other'
}

/** Absolute change: "+0.09р." / "−0.05р."; zero/missing → "". */
export function formatRubChange(changes) {
  const rub = changes?.rub
  if (rub == null || rub === 0) return ''
  const sign = rub > 0 ? '+' : '−'
  return `${sign}${Math.abs(Number(rub)).toFixed(2)}р.`
}

/** Percent change: "+0.14%"; zero/missing → "". */
export function formatPercentChange(changes) {
  const percent = changes?.percent
  if (percent == null || percent === 0) return ''
  const sign = percent > 0 ? '+' : '−'
  return `${sign}${Math.abs(Number(percent)).toFixed(2)}%`
}

/** Price as "64.90р." (estimated prefix handled by caller). */
export function formatFuelCardPrice(price) {
  const n = Number(price)
  if (!Number.isFinite(n)) return '—'
  return `${n.toFixed(2)}р.`
}

const RESTRICTION_STATUS_LABELS = {
  has_limit: 'Есть лимит',
  unknown: 'Неизвестно',
  possibly_available: 'Возможно доступно',
  unavailable: 'Отсутствует',
  absent: 'Отсутствует',
  missing: 'Отсутствует',
  not_available: 'Отсутствует',
  out_of_stock: 'Отсутствует',
  possibly_unavailable: 'Возможно отсутствует',
  possibly_absent: 'Возможно отсутствует',
  possibly_missing: 'Возможно отсутствует',
  maybe_absent: 'Возможно отсутствует',
  uncertain: 'Возможно отсутствует'
}

function restrictionStatusLabel(status) {
  if (status == null || status === '') return ''
  const key = String(status).trim().toLowerCase()
  if (!key || key === 'available') return ''
  if (RESTRICTION_STATUS_LABELS[key]) return RESTRICTION_STATUS_LABELS[key]
  return String(status).trim().replace(/_/g, ' ')
}

/**
 * Orange restriction lines for a fuel card.
 * Plastic limit + all.status (hide when available).
 */
export function restrictionDisplayLines(restrictions) {
  if (!restrictions || typeof restrictions !== 'object') return []
  const lines = []

  const limit = restrictions.plastic?.limit
  if (typeof limit === 'number' && Number.isFinite(limit)) {
    lines.push({ key: 'plastic-limit', text: `Лимит до ${limit} л.` })
  }

  const statusText = restrictionStatusLabel(restrictions.all?.status)
  if (statusText) {
    lines.push({ key: 'all-status', text: statusText })
  }

  return lines
}
